import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
`;

export const Slider = styled.div`
  display: flex;
  transition: transform 0.6s ease-in-out;
  width: 100%;
`;

export const Slide = styled.div`
  min-width: 100%;
`;

export const DotsContainer = styled.div`
  position: absolute;
  bottom: 1.2rem;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 0.6rem;
  z-index: 2;
`;

export const Dot = styled.button<{ active: boolean }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  background-color: ${({ active }) =>
    active ? "var(--white)" : "var(--gray-45)"};
  cursor: pointer;
  transition: background-color 0.3s ease;
`;
